import ServiceManagementApi from "@/services/ServiceManagement";
import config from "@/config";

export default {
	state: {
		enabledFeatures: {},
		featuresUsageCounterMap: {},
		userPreferences: JSON.parse(localStorage.getItem("userPreferences") || "{}"),
		acceptTransferHostOverlay: false,
		availableOrganizations: []
	},

	getters: {
		featuresLoaded: (state) => (object_id) => {
			return state.enabledFeatures[object_id];
		},

		isFeatureEnabled: (state) => ({object_id, service_id = config.ZETTACLOUD_SERVICE_ID, reference}) => {
			let features = state.enabledFeatures[object_id]?.find(i => i.service_id === service_id)?.features;
			if (features) {
				return features.some(f => f.reference === reference);
			}
			return false;
		},

		isFeatureEnabledByAssetTypeID: (state) => ({object_id, service_id = config.ZETTACLOUD_SERVICE_ID, reference, asset_type_id}) => {
			const feature = state.enabledFeatures[object_id]
				?.find(i => i.service_id === service_id)
				?.features?.find(f => f.reference === reference);

			if (!feature) {
				return false;
			}

			const conditions = JSON.parse(feature.condition || "[]");

			return conditions.length === 0
				|| conditions.some(c => c.assetTypeID && c.assetTypeID === asset_type_id);
		},

		userPreferences: (state) => (key) => {
			if (key) {
				return state.userPreferences[key];
			}
			return state.userPreferences;
		},

		getAcceptTransferHostOverlay: (state) => () => {
			return state.acceptTransferHostOverlay;
		},

		getAvailableOrganizations: (state) => () => {
			return state.availableOrganizations;
		}
	},

	mutations: {
		setEnabledFeatures(state, {object_id, data}) {
			if (!state.enabledFeatures[object_id]) {
				state.enabledFeatures[object_id] = [];
			}
			state.enabledFeatures[object_id].push(data);
		},

		incrementFeaturesUsageCounter(state, object_id) {
			if (!state.featuresUsageCounterMap[object_id]) {
				state.featuresUsageCounterMap[object_id] = 0;
			}
			state.featuresUsageCounterMap[object_id]++;
		},

		removeEnabledFeatures(state, object_id) {
			if (state.featuresUsageCounterMap[object_id] === 1) {
				delete state.enabledFeatures[object_id];
			}
			state.featuresUsageCounterMap[object_id]--;
		},

		setUserPreferences(state, data) {
			state.userPreferences = {...state.userPreferences, ...data};
			localStorage.setItem("userPreferences", JSON.stringify(state.userPreferences));
		},

		setAcceptTransferHostOverlay(state, isOpen) {
			state.acceptTransferHostOverlay = isOpen;
		},

		setAvailableOrganizations(state, organizations) {
			state.availableOrganizations = organizations;
		}
	},

	actions: {
		getUserFeatures({getters, commit}, {object_id, service_id = config.ZETTACLOUD_SERVICE_ID}) {
			if (getters.featuresLoaded(object_id)) {
				commit("incrementFeaturesUsageCounter", object_id);
				return Promise.resolve();
			}
			return ServiceManagementApi.getUserFeatures({service_id, object_id})
									   .then(res => {
										   if (res.status === 200) {
											   commit("incrementFeaturesUsageCounter", object_id);
											   commit("setEnabledFeatures", {object_id, data: res.data[0]});
										   }
									   })
									   .catch(() => {
										   commit(
											   "SHOW_NOTIFICATION_WITH_TYPE",
											   {message: "An error occurred when trying to load User features."}
										   )
									   });
		},

		getServiceFeatures(state, {service_id = config.ZETTACLOUD_SERVICE_ID} = {}) {
			return ServiceManagementApi.getServiceFeatures({service_id});
		},

		toggleNowPlayingEventProgressCountdown({commit}, countdownEnabled) {
			commit("setUserPreferences", {nowPlayingEventProgressCountdownEnabled: countdownEnabled});
		},

		getUserByID({commit}, userID) {
			return ServiceManagementApi.getUserByID(userID)
									   .then(response => response.data)
									   .catch(() =>
										   commit(
											   "SHOW_NOTIFICATION_WITH_TYPE",
											   {message: `An error occurred when trying to load the user with id ${userID}.`}
										   )
									   );
		}
	}
};